import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'caret-down-icon',
  templateUrl: './caret-down-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CaretDownIconComponent {}
